<template>
  <div class="p-2">
    <b-card header="Default">
      <div slot="header">
        فرم {{ $lang.researchLang.closeResearchPlanReasonLabel }}
      </div>
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-row v-if="!isLoading">
        <b-col cols="12" md="12">
          <b-alert show variant="danger">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b
              v-text="
                'این روش اتمام عملیات تحقیق زمانی استفاده شود که به هر دلیل قبل از تکمیل کامل عملیات تحقیق می خواهید آنرا بصورت ناتمام (ناقص) رها  کنید و فرایند را خاتمه دهید این داده بعنوان داده ناقص در نظر گرفته شده و در نتیجه نهایی تحقیق لحاظ نمی شود'
              "
            />
          </b-alert>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="`${$lang.researchLang.closeResearchPlanReasonLabel}:`"
            label-for="description"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="`${$lang.researchLang.closeResearchPlanReasonLabel}:`"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              type="text"
              v-model="$v.description.$model"
              :rows="this.$config.form.textareaRows"
              :state="$v.description.$dirty ? !$v.description.$error : null"
            />
            <b-form-invalid-feedback id="description-feedback">
              {{
                $lang.error_required
                  | replace($lang.researchLang.closeResearchPlanReasonLabel)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button variant="success" @click="submit">
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="closeModal"
          >
            {{ $lang.cancelButton }}
            <i class="fa fa-ban"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";

export default {
  validations: {
    description: {
      required,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      description: null,
    };
  },
  methods: {
    pathOr,
    closeModal() {
      this.$emit("closeModal");
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        const url =
          this.$config.api_url +
          this.$config.research.research_plan_detail.replace("{0}", this.id);
        const payload = {
          research_status_id: 3,
          close_before_complete: this.description,
        };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("refreshPlanDetail");
        this.closeModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

